const { default: components } = require('./componentsDictionary');

const compDictName = components.reduce((prev, curr) => {
	return Object.assign(prev, { [curr.componentName]: curr.name });
}, {});

function renderPageJson(page) {
	const pageComps = page.pageData;
	const pageType = page.pageType;
	if (pageType === 'header') {
		const content = {
			[pageType]: {
				blocks: getPageBlocks(pageComps),
			},
			[pageType + '.full']: {
				blocks: getPageBlocks(pageComps),
			},
		};
		//pois deveria ser sempre o primeiro e unico elemento
		fillContentWithComponents(content, pageComps);
		return content;
	} else if (pageType == 'footer') {
		return {};
	} else if (pageType === 'search') {
		const content = {
			'store.search': {
				blocks: ['search-result-layout'],
				props: {
					context: {
						skusFilter: 'ALL',
						simulationBehavior: 'default',
					},
				},
			},
			'search-result-layout': {
				blocks: getPageBlocks(pageComps),
			},
		};

		fillContentWithComponents(content, pageComps);

		return content;
	} else {
		const pageKey = 'store.' + pageType;
		//ex {store.home:{}}
		const content = {
			[pageKey]: { blocks: getPageBlocks(pageComps) },
		};
		//pois deveria ser sempre o primeiro e unico elemento
		fillContentWithComponents(content, pageComps);
		return content;
	}
}

function getPageBlocks(pageComps) {
	return pageComps
		.map((row) => {
			return getVtexCompName(row);
		})
		.filter((el) => el);
}

function fillContentWithComponents(page, pageComps) {
	pageComps.map((row) => {
		const childrenComponents = row.childrenComponents;
		page[getVtexCompName(row)] = {
			props: getComponentProps(row.props),
			children: getComponentChildrenRecursive(page, childrenComponents),
			blocks: row.blocks && getComponentChildrenRecursive(page, row.blocks),
		};
	});
}

function getComponentProps(comp) {
	if (!comp) return {};
	const newComp = JSON.parse(JSON.stringify(comp));
	delete newComp.children;
	Object.keys(newComp).forEach((prop) => {
		if (newComp[prop] !== null && newComp[prop].length === 0) {
			delete newComp[prop];
		}
	});
	return newComp;
}
function getComponentChildrenRecursive(page, components) {
	//feito pra um componente por linha, mas não deve ser muito treta modificar aqui pra suportar mais, o maior ajuste será pelo react
	if (!components || !components.length) return [];
	const newComps = JSON.parse(JSON.stringify(components));
	return newComps.map((row) => {
		const childrenComponents = row.childrenComponents;
		const vtexCompName = getVtexCompName(row);
		if (row.componentName === 'Minicart') {
			page[vtexCompName] = {
				props: getComponentProps(row.props),
				children: 'minicart-base-content',
			};

			return vtexCompName;
		}
		page[vtexCompName] = {
			props: getComponentProps(row.props),
			children: getComponentChildrenRecursive(page, childrenComponents),
			blocks: row.blocks && getComponentChildrenRecursive(page, row.blocks),
		};

		return vtexCompName;
	});

	// newComp.children
}

function getVtexCompName(component) {
	const compName = component.componentName;
	const componentId = component.componentId;
	if (!compDictName[compName]) {
		return console.error(`Componente ${compName} não encontrado, verifiquei o objeto compDictName`);
	}
	if (
		compName === 'HeaderDesktop' ||
		compName === 'HeaderMobile' ||
		compName === 'FooterDesktop' ||
		compName === 'FooterMobile'
	) {
		return `${compDictName[compName]}#${compName}-${componentId}`;
	}
	return compDictName[compName] + '#' + compName + '-' + componentId;
}

export default renderPageJson;
